import { render, staticRenderFns } from "./product-view-circle.vue?vue&type=template&id=161f499d&scoped=true&"
import script from "./product-view-circle.vue?vue&type=script&lang=js&"
export * from "./product-view-circle.vue?vue&type=script&lang=js&"
import style0 from "./product-view-circle.vue?vue&type=style&index=0&id=161f499d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "161f499d",
  null
  
)

export default component.exports